import styled from "styled-components";


export const Container = styled.div`

    .max-card{
        max-height: fit-content;
    }

    .styles-description{
        padding: 20px;
    }
    .styles-image{
        margin: 20px;
    }
`;

export const MainContainer = styled.div`

`;


export const InputsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2,1fr);
    width: 100%;
    padding: 0 30px;

    @media (max-width: 768px){
        display:flex;
        flex-direction:column;
    }
`;

export const ButtonContainer = styled.div`
    display:flex;
    widht:100%;
    justify-content:center;
    align-items:center;
`;


